import React from "react";
import { Slider, Box } from "@mui/material";

type Props = {
  value: [number, number];
  onChange: (min: number, max: number) => void;
  onCommit: () => void;
};

const BlueSlider: React.FC<Props> = ({ value, onChange, onCommit }) => (
    <Box>
      <Slider
          value={value}
          min={0}
          max={100}
          step={1}
          disableSwap
          onChange={(_, v) => Array.isArray(v) && onChange(v[0], v[1])}
          onChangeCommitted={onCommit}
          valueLabelDisplay="auto"
          sx={{
            paddingY: 1.5,
            "& .MuiSlider-track": {
              height: 6,
              borderRadius: 9999,
              background: "linear-gradient(to right,#1d4ed8,#60a5fa)",
            },
            "& .MuiSlider-rail": {
              height: 6,
              borderRadius: 9999,
              opacity: 0.35,
              background: "#ffffff12",
            },
            "& .MuiSlider-thumb": {
              width: 16,
              height: 16,
              backgroundColor: "#e0f2fe",
              border: "2px solid #1d4ed8",
              borderRadius: "9999px",
            },
          }}
      />
    </Box>
);

export default BlueSlider;
